import React from 'react';
import { connect } from 'react-redux';


// Components

import SsapNavBar from '@components/ssap/navigation/SsapNavBar';


// Constants

import { EXCEPTIONS } from '@constants/ssap/exceptions/ssapExceptions';



const SsapNavBarContainer = props => {

    const {
        exception,
        isShown,
    } = props;

    if(!isShown) {
        return null;
    }

    const getContent = () => {
        if(exception !== null && exception.exceptionType === EXCEPTIONS.REVIEW_AFTER_SIGN) {
            return null;
        } else {
            return <SsapNavBar />;
        }
    };

    return (
        <aside className="usa-layout-docs__sidenav desktop:grid-col-3">
            <div className="gi-leftnav-container">
                {
                    getContent()
                }
            </div>
        </aside>
    );
};

const mapStateToProps = state => ({
    exception: state.ssap.exception
});

export default connect(mapStateToProps)(SsapNavBarContainer);